import config from "../config";

const authService = {
  isAuth: () => {
    const sessionToken = sessionStorage.getItem(config.TOKEN);
    const localToken = localStorage.getItem(config.TOKEN);
    return (sessionToken !== null && sessionToken !== undefined) || 
           (localToken !== null && localToken !== undefined) ||
           config.IS_DEV;
  },

  login: (token, stayLoggedIn = false) => {
    if (stayLoggedIn) {
      localStorage.setItem(config.TOKEN, token);
      sessionStorage.removeItem(config.TOKEN);
    } else {
      sessionStorage.setItem(config.TOKEN, token);
      localStorage.removeItem(config.TOKEN);
    }
  },

  logout: () => {
    sessionStorage.removeItem(config.TOKEN);
    localStorage.removeItem(config.TOKEN);
  },

  getToken: () => {
    return localStorage.getItem(config.TOKEN) || sessionStorage.getItem(config.TOKEN);
  }
};

export default authService;
